import { lazyPage } from "@/router/lazyPage";

export const AcceptInvite = lazyPage(() => import("@/pages/AcceptInvite"), "AcceptInvite");
export const AccessLocked = lazyPage(() => import("@/pages/AccessLocked"), "AccessLocked");
export const Billing = lazyPage(() => import("@/pages/Billing"), "Billing");
export const MemberDisabled = lazyPage(() => import("@/pages/MemberDisabled"), "MemberDisabled");
export const NoOrgAccess = lazyPage(() => import("@/pages/NoOrgAccess"), "NoOrgAccess");
export const Onboarding = lazyPage(() => import("@/pages/Onboarding"), "Onboarding");
export const ProjectLegacyRedirect = lazyPage(
  () => import("@/pages/Project/ProjectLegacyRedirect"),
  "ProjectLegacyRedirect",
);
